export const VIDEO_MEDIA_MAX_UPLOAD_SIZE = 1000 * 1000 * 1000;
export const OTHER_MEDIA_MAX_UPLOAD_SIZE = 50 * 1000 * 1000;
export const EXCEL_MAX_UPLOAD_SIZE = 20 * 1000 * 1000;
